import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

/** حقول كل قطعة كما يتعارف عليها السوق — تُنسَّق داخل التصميم نفسه (لا كظل فوقه) */
export const DESIGN_FIELDS = {
  logo: [
    { k: "brand_name", l: "اسم العلامة (كما يُكتب على اللوقو) *", p: "مثال: شاورما كلاسيك" },
    { k: "industry", l: "النشاط / المجال *", p: "مطعم، عيادة، عقار، تقنية…" },
    { k: "colors", l: "الألوان (اختياري — نلتزم بها حرفيًا)", p: "ذهبي وكحلي / أخضر وأبيض / #1F3A5F…" },
    { k: "slogan", l: "شعار نصي قصير", p: "مثال: نكهة سعودية أصيلة", adv: true },
    { k: "symbols", l: "رموز أو عناصر تريدها", p: "نخلة، هلال، فنجان، خط عربي…", adv: true },
    { k: "avoid", l: "ما تريد تجنّبه", p: "بلا وجوه، بلا تدرجات…", adv: true },
  ],
  business_card: [
    { k: "person_name", l: "الاسم على البطاقة *", p: "محمد العتيبي" },
    { k: "job_title", l: "المسمى الوظيفي", p: "المدير التنفيذي" },
    { k: "phone", l: "رقم الجوال *", p: "05xxxxxxxx", ltr: true },
    { k: "email", l: "البريد الإلكتروني", p: "name@company.com", ltr: true },
    { k: "photo", l: "صورتك الشخصية — تظهر دائرية على البطاقة وفي البطاقة الرقمية وتُحفظ مع جهة الاتصال", image: true },
    { k: "whatsapp", l: "واتساب (إن اختلف عن الجوال)", p: "05xxxxxxxx", ltr: true, adv: true },
    { k: "website", l: "الموقع الإلكتروني", p: "www.example.com", ltr: true, adv: true },
    { k: "address", l: "العنوان", p: "الرياض — حي الملز", adv: true },
    { k: "instagram", l: "إنستغرام", p: "@handle", ltr: true, adv: true },
    { k: "x", l: "إكس (X)", p: "@handle", ltr: true, adv: true },
    { k: "snapchat", l: "سناب شات", p: "@handle", ltr: true, adv: true },
    { k: "tiktok", l: "تيك توك", p: "@handle", ltr: true, adv: true },
    { k: "linkedin", l: "لينكدإن", p: "اسم المستخدم أو الرابط", ltr: true, adv: true },
    { k: "qr_link", l: "رابط رمز QR", p: "https://wa.me/9665xxxxxxxx أو رابط خرائط قوقل أو موقعك", hint: "يُحوَّل إلى رمز QR حقيقي داخل التصميم.", adv: true, ltr: true },
  ],
  cover: [
    { k: "headline", l: "العنوان الرئيسي *", p: "عرض الافتتاح الكبير" },
    { k: "subline", l: "سطر فرعي", p: "خصم 30% لأول أسبوع" },
    { k: "cta", l: "دعوة لاتخاذ إجراء", p: "اطلب الآن / احجز موعدك", adv: true },
    { k: "features", l: "3 مزايا قصيرة (سطر لكل ميزة)", p: "توصيل سريع\nدفع آمن\nضمان الجودة", multi: true, adv: true },
    { k: "contact", l: "معلومات تواصل أسفل الغلاف", p: "0500000000 — الرياض", adv: true },
    { k: "qr_link", l: "رابط رمز QR", p: "https://wa.me/9665xxxxxxxx أو رابط خرائط قوقل أو موقعك", hint: "يُحوَّل إلى رمز QR حقيقي داخل التصميم.", adv: true, ltr: true },
  ],
  menu: [
    { k: "menu_title", l: "عنوان القائمة *", p: "قائمة الطعام / قائمة الأسعار" },
    { k: "menu_items", l: "الأصناف والأسعار (سطر لكل صنف: الاسم - السعر) *", p: "شاورما دجاج - 12\nشاورما لحم - 14\nصحن مشكل - 28\nبروستد - 24", multi: true, rows: 6 },
    { k: "currency_note", l: "ملاحظة الأسعار", p: "الأسعار شاملة الضريبة", adv: true },
    { k: "contact", l: "تواصل / فرع", p: "0500000000 — شارع المتنبي", adv: true },
    { k: "qr_link", l: "رابط رمز QR", p: "https://wa.me/9665xxxxxxxx أو رابط خرائط قوقل أو موقعك", hint: "يُحوَّل إلى رمز QR حقيقي داخل التصميم.", adv: true, ltr: true },
  ],
  infographic: [
    { k: "headline", l: "عنوان الإنفوجرافيك *", p: "٥ أسباب لاختيارنا" },
    { k: "points", l: "النقاط (سطر لكل نقطة، 3–6) *", p: "توصيل خلال 24 ساعة\nدفع آمن عبر مدى\nاسترجاع خلال 14 يومًا", multi: true, rows: 6 },
    { k: "source", l: "مصدر / تذييل", p: "المصدر: تقرير 2025", adv: true },
    { k: "qr_link", l: "رابط رمز QR", p: "https://wa.me/9665xxxxxxxx أو رابط خرائط قوقل أو موقعك", hint: "يُحوَّل إلى رمز QR حقيقي داخل التصميم.", adv: true, ltr: true },
  ],
  brochure: [
    { k: "headline", l: "عنوان الغلاف *", p: "أصالة تُروى للأجيال" },
    { k: "subline", l: "سطر فرعي", p: "شاورما كلاسيك منذ 1984" },
    { k: "features", l: "خدمات / مزايا (سطر لكل بند، 3–5)", p: "شاورما عربي أصيلة\nعروض يومية\nتوصيل سريع", multi: true, rows: 5 },
    { k: "cta", l: "دعوة لاتخاذ إجراء", p: "اطلب الآن", adv: true },
    { k: "contact", l: "معلومات التواصل", p: "0500000000 — www.example.com — الرياض", adv: true },
    { k: "qr_link", l: "رابط رمز QR", p: "https://wa.me/9665xxxxxxxx أو رابط خرائط قوقل أو موقعك", hint: "يُحوَّل إلى رمز QR حقيقي داخل التصميم.", adv: true, ltr: true },
  ],
};

/** يبني وصفًا من الحقول ليصبح الطلب كاملًا حتى لو لم يكتب العميل وصفًا حرًا */
export const designSummary = (kind, v = {}) => {
  const f = DESIGN_FIELDS[kind] || [];
  const parts = f.filter((x) => !x.image && (v[x.k] || "").trim()).map((x) => `${x.l.replace(" *", "")}: ${v[x.k].trim().replace(/\n/g, "، ")}`);
  return parts.join(" — ");
};

const ImageField = ({ value, onChange, testId }) => {
  const pick = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {  // تصغير إلى 600px وضغط JPEG حتى تبقى الصورة خفيفة داخل البيانات
      const side = Math.min(img.width, img.height), c = document.createElement("canvas"); c.width = c.height = 600;
      c.getContext("2d").drawImage(img, (img.width - side) / 2, (img.height - side) / 2, side, side, 0, 0, 600, 600);
      onChange(c.toDataURL("image/jpeg", 0.85)); URL.revokeObjectURL(url);
    };
    img.src = url;
  };
  return (
    <div className="flex items-center gap-3">
      {value && <img src={value} alt="" className="w-14 h-14 rounded-full object-cover ring-2 ring-primary/40" data-testid={`${testId}-preview`} />}
      <label className="flex-1 cursor-pointer">
        <input type="file" accept="image/*" className="hidden" onChange={pick} data-testid={testId} />
        <div className="rounded-lg border border-dashed border-border bg-background py-2 text-center text-xs text-muted-foreground hover:border-primary/40">{value ? "تغيير الصورة" : "رفع صورة شخصية"}</div>
      </label>
      {value && <button type="button" onClick={() => onChange("")} className="text-xs text-destructive" data-testid={`${testId}-remove`}>إزالة</button>}
    </div>
  );
};

export const DesignFields = ({ kind, value = {}, onChange }) => {
  const all = DESIGN_FIELDS[kind];
  const [adv, setAdv] = React.useState(false);
  if (!all) return null;
  const hasAdv = all.some((f) => f.adv);
  const fields = all.filter((f) => !f.adv || adv || (value[f.k] || "").trim());
  const set = (k, val) => onChange({ ...value, [k]: val });
  return (
    <div className="rounded-xl border border-primary/40 bg-primary/5 p-3 space-y-3" data-testid="design-fields">
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs font-bold text-primary">{kind === "logo" ? "٣ حقول تكفي — ثم اختر مفهومًا من المقترحات بالأسفل" : "حقول الخدمة — تُنسَّق داخل التصميم في مواضعها الصحيحة"}</p>
        {hasAdv && <button type="button" onClick={() => setAdv((a) => !a)} className="text-[11px] text-primary underline shrink-0" data-testid="design-advanced-toggle">{adv ? "إخفاء الخيارات الإضافية" : "خيارات إضافية"}</button>}
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        {fields.map((f) => (
          <div key={f.k} className={`min-w-0 ${f.multi ? "md:col-span-2" : ""}`}>
            <Label className="mb-1 block text-xs">{f.l}</Label>
            {f.image
              ? <ImageField value={value[f.k] || ""} onChange={(val) => set(f.k, val)} testId={`design-${f.k}`} />
              : f.multi
              ? <Textarea value={value[f.k] || ""} onChange={(e) => set(f.k, e.target.value)} placeholder={f.p} rows={f.rows || 3} className="bg-background border-border text-sm" data-testid={`design-${f.k}`} data-optional={f.l.includes("*") ? undefined : ""} />
              : <><Input value={value[f.k] || ""} onChange={(e) => set(f.k, e.target.value)} placeholder={f.p} dir={f.k === "qr_link" || f.ltr ? "ltr" : undefined} className="bg-background border-border text-sm" data-testid={`design-${f.k}`} data-optional={f.l.includes("*") ? undefined : ""} />
                {f.hint && <p className="text-[11px] text-muted-foreground mt-1" data-testid={`design-hint-${f.k}`}>{f.hint}</p>}</>}
          </div>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground">
        {kind === "menu" ? "كل سطر «اسم الصنف - السعر»، والأسطر بلا سعر تُعرض كأصناف فقط. الصور والمشهد نولّدها نحن بهوية سعودية تناسب نشاطك." : "ما تتركه فارغًا نكمله بنص عربي مدقَّق يناسب نشاطك — دون اختراع أرقام أو أسعار."}
      </p>
    </div>
  );
};
